import { render, staticRenderFns } from "./eventList.vue?vue&type=template&id=226b22ad"
import script from "./eventList.vue?vue&type=script&lang=ts"
export * from "./eventList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports